import { Fragment } from "react";
import MainContent from "./components/MainContent";


import './styles/index.scss'

function App() {
  return (
  <Fragment>
    <MainContent />
  </Fragment>
  );
}

export default App;
